import React from 'react'
import './Experience.css'
import {useContext} from "react"
import {themeContext, ThemeProvider} from '/Users/kritikpatni/portfolio-website/src/Context.js'
function Experience() {

  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;  
  
  return (
    <div className="experience" id='Experience'>
    <div className="achievement">
      {/* darkMode */}
      <div className="circle" style={{color: darkMode?'var(--orange)':''}}>2+</div>
      <span  style={{color: darkMode?'white':''}}>Years </span>
      <span>Experience</span>
    </div>
    <div className="achievement">
      <div className="circle" style={{color: darkMode?'var(--orange)':''}}>20+</div>
      <span  style={{color: darkMode?'white':''}}>Projects </span>
      <span>Completed</span>
    </div>
    
  </div>
  )
}

export default Experience
